import { useQuery } from '@tanstack/react-query';
import { userApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useUserLogins(userId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.users.logins(userId ?? -1),
    queryFn: ({ signal }) =>
      userApiClient.getUserLogins(userId!, toCancelToken(signal)),
    enabled: userId != null,
    staleTime: 60_000,
    meta: { errorContext: 'user login history' },
  });
}
